import React from 'react';
import MobileNavigationItem from './RutabMobileNavigationItem';
import { useSelector } from 'react-redux';

const MobileNavigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const languageSelector = useSelector((state) => state.navigation.languageTextEditor)

    return  <MobileNavigationItem links={contentLinks} languageSelector={languageSelector}/>;
};

export default MobileNavigation;
